"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_jss_1 = __importDefault(require("react-jss"));
var Logo_1 = __importDefault(require("./Logo"));
var Logo_styles_1 = __importDefault(require("./Logo.styles"));
exports.default = react_jss_1.default(Logo_styles_1.default)(Logo_1.default);
//# sourceMappingURL=index.js.map